module.exports = __webpack_public_path__ + "static/media/laptop.99755cea.svg";